import React, { createContext, Dispatch, ReactNode, SetStateAction } from 'react'
import { AccountContactsContext } from 'components/accountContact/helpers/types'
import { BusinessAddressFormData as BusinessAddressDataV1 } from 'pages/Verification/BusinessAddress/BusinessAddressV1/helpers/types'
import { BusinessAddressData as BusinessAddressDataV2 } from 'pages/Verification/BusinessAddress/BusinessAddressV2/helpers/types'
import { DynamicFieldsData } from 'types/dynamicFields'
import { DataContext } from 'types/reactQuery'
import { VerificationRouteKey } from 'types/verification'

export type VerificationContextData = {
  businessAddress?: DataContext<BusinessAddressDataV2 | BusinessAddressDataV1>
  accountContacts?: AccountContactsContext
  dynamicFields?: DataContext<DynamicFieldsData>
}

export interface VerificationRouteProps extends VerificationContextData {
  hasCompletedSteps: boolean
  setActiveRoute: Dispatch<SetStateAction<VerificationRouteKey>>
  setUnsavedChanges: Dispatch<SetStateAction<boolean>>
  submitStep: () => void
}

export interface VerificationContextProviderProps extends VerificationRouteProps {
  children: ReactNode
}

const functionDefaultValue = () => null

const dataContextDefaultValues = {
  isFetching: false,
  isError: false,
  refetch: functionDefaultValue,
}

export const VerificationContext = createContext<VerificationRouteProps>({
  businessAddress: {
    ...dataContextDefaultValues,
    data: null,
  },
  accountContacts: {
    isEnabled: false,
    isFetching: false,
    isFetchingError: false,
    list: [],
    setList: functionDefaultValue,
    refetch: functionDefaultValue,
  },
  dynamicFields: {
    ...dataContextDefaultValues,
    data: { documents: [], questions: [] },
  },
  hasCompletedSteps: false,
  setActiveRoute: functionDefaultValue,
  setUnsavedChanges: functionDefaultValue,
  submitStep: functionDefaultValue,
})

export const VerificationContextProvider = ({
  children,
  ...contextReturnValues
}: VerificationContextProviderProps) => {
  return (
    <VerificationContext.Provider value={contextReturnValues}>
      {children}
    </VerificationContext.Provider>
  )
}
